import { createContext } from 'react';
import 'mobx-react-lite/batchingForReactDom';
import { decorate, observable, action } from 'mobx';

class ChromeTabs {
  openTabs = [];
  async setOpenTabs(tabs: any) {
    this.openTabs = tabs;
  }
}
decorate(ChromeTabs, {
  openTabs: observable,
  setOpenTabs: action.bound,
});

export const ChromeBridge = new ChromeTabs();
export const ChromeContext = createContext(ChromeBridge);
